module.exports = __webpack_public_path__ + "img/finance-application-display-ford.c95e32cb.png";